import { DEBUG_BUILD as i } from "./chunk1080.js";
import { WINDOW as o } from "./chunk1078.js";
import { logger as s } from "./chunk870.js";
import { getCurrentScope as f } from "./chunk868.js";
import { lastEventId as g } from "./chunk865.js";
import { getReportDialogEndpoint as p } from "./chunk1081.js";
function I(e = {}) {
  if (!o.document) {
    i && s.error("Global document not defined in showReportDialog call");
    return;
  }
  const n = f(), c = n.getClient(), d = c && c.getDsn();
  if (!d) {
    i && s.error("DSN not configured for showReportDialog call");
    return;
  }
  if (n && (e.user = {
    ...n.getUser(),
    ...e.user
  }), !e.eventId) {
    const t = g();
    t && (e.eventId = t);
  }
  const r = o.document.createElement("script");
  r.async = !0, r.crossOrigin = "anonymous", r.src = p(d, e), e.onLoad && (r.onload = e.onLoad);
  const { onClose: a } = e;
  if (a) {
    const t = (m) => {
      if (m.data === "__sentry_reportdialog_closed__")
        try {
          a();
        } finally {
          o.removeEventListener("message", t);
        }
    };
    o.addEventListener("message", t);
  }
  const l = o.document.head || o.document.body;
  l ? l.appendChild(r) : i && s.error("Not injecting report dialog. No injection point found in HTML");
}
export {
  I as showReportDialog
};
